module.exports = __webpack_public_path__ + "static/media/15UN-Habitat8.e3f03ae1.jpg";